/** 活动业务模块 */
import actions from '../action/business';
import CONSTANT from '../constant/business';
import _ from 'underscore';

export default {
  actions,
  state: {
    /* 企业专区商品信息, areaPrice 覆盖默认价格 */
    companyProductInfo: {}
  },
  mutations: {
    [CONSTANT.BUSINESS_ENTERPRISE_PRODUCT_INFO_SUCCESS](state, data) {
      state.companyProductInfo = data;
    },
    [CONSTANT.BUSINESS_ENTERPRISE_PRODUCT_INFO_ERROR](state) {
      state.companyProductInfo = {};
    }
  }
};
